// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"69":"b07336ce","144":"2d0b9fdb","149":"7141e8ba","265":"c3b757d4","478":"764d2cea"}[chunkId] + ".chunk.js";
};